@if(tenants?.length) {
    <div>
        <p>Please choose a tenant to proceed:</p>
        <div class="form-group">
            <select class="form-select" id="selectTenant" name="selectTenant"
                    [(ngModel)]="selectedTenantKey"
                    (change)="onTenantChange()">
                <option [ngValue]="null" disabled selected hidden>Please Select</option>
                @for (tenant of sortedTenants; track tenant.key) {
                    <option [ngValue]="tenant.key">{{ tenant.name || tenant.key }}</option>
                }
            </select>
            @if (tenant_invalid) {
                <div class="alert alert-danger" id="tenantSelectionError">
                    Please select a Tenant
                </div>
            }
        </div>
        <aurora-button block variant="primary" class="my-3"
            id="selectTenantButton"
            [disabled]="!selectedTenant"
            (click)="onSelectButtonClick()">
            Select Tenant
        </aurora-button>
        <div class="center mt-3">
            <aurora-link-button id="changeUserButton" (click)="onChangeUser.emit()">
                Change User
            </aurora-link-button>
        </div>
    </div>
} @else {
    <ng-container>
        <p>
            You do not have access to any tenants. Please contact an administrator to add you to a tenant.
        </p>
        <aurora-link-button class="nav-item" (click)="onChangeUser.emit()">
            Back to login
        </aurora-link-button>
    </ng-container>
}